var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component.component && ((_vm.component.component) + "Config"),{tag:"component",attrs:{"formSelect":_vm.component,"formData":_vm.formData},on:{"onChangeFormData":_vm.handleFormData}})}
var staticRenderFns = []

export { render, staticRenderFns }